import React, { PureComponent, ReactNode } from "react";
import { Animated } from "react-animated-css";
import { Redirect } from "react-router-dom";
import Navbar from "../../components/CustomNav/CustomNav.Component";

import {
  Container,
  MenuGrid,
  MenuGridItem,
} from "../Teachers/TeacherMenu.styles";
import profileImg from "../../assets/images/mainmenus/profile.png";
import helpImg from "../../assets/images/mainmenus/help.png";
import alertsImg from "../../assets/images/mainmenus/risk-level.png";
import learnersImg from "../../assets/images/mainmenus/learners.png";
import skillsImg from "../../assets/images/mainmenus/skills.png";
import reportCenter from "../../assets/images/mainmenus/reportcenter.png";
import learningImg from "../../assets/images/mainmenus/perception.png";
import { currentUser, isUserLoggedIn } from "src/common/services";
import { Content, PickerHeader } from "../DataCenter/CourseDetails/CourseDetails.styles";
import { ContentRow, SearchItemsList, UserSearchItem } from "../DataCenter/DataCentre.styles";
import withServices from "src/HOCs/withServices";

interface Props {
  history: any;
  isDataCentre?: any;
  services?: any;
}
interface State {
  path: string;
  toLogin: boolean;
}
const dataCentreItems = [
  {
    title: "Learner Engagement",
    description:
      "Here you can deep dive into each learner's system interaction.",
    color: "#acff24",
    bg: profileImg,
    to: "/schools/learner-engagement",
  },
  {
    title: "Course Performance",
    description:
      "Have a look at your institutions overall course and lesson performance",
    color: "#ff7a03",
    bg: learnersImg,
    to: "/schools/datacentre",
  },
];

const schoolItems = [
  {
    title: "Profile",
    description: "Amend or review any settings",
    color: "#acff24",
    bg: profileImg,
    to: "/schools/profilepage",
  },
  {
    title: "Learners",
    description: "Deep dive into each of your learners profiles",
    color: "#ff7a03",
    bg: learnersImg,
    to: "/schools/studentlist",
  },
  {
    title: "Alerts",
    description: "Explore the 5 alert levels",
    color: "#ff0033",
    bg: alertsImg,
    to: "/schools/home",
  },
  {
    title: "Perceptions",
    description: "Explore the 8 key perception indicators",
    color: "#3ee9f7",
    bg: learningImg,
    to: "/schools/perceptions",
  },
  {
    title: "Quick Glance",
    description:
    "Take full advantage and gain access to all of your reports and insights",
    color: "#9143fc",
    bg: reportCenter,
    to: "/schools/quickglance",
  },
  {
    title: "Performance Center",
    description: "View your learner's progress on their learning pathways",
    color: "#ff7a03",
    bg: reportCenter,
    to: "/schools/data-centre-menu",
  },
  {
    title: "Report Center",
    description:
      "Take full advantage and gain access to all of your reports and insights",
    color: "#acff24",
    bg: reportCenter,
    to: "/schools/report-center",
  },
  // {
  //   title: "Help",
  //   description: "Take a pit stop in the help center",
  //   color: "#9143fc",
  //   bg: helpImg,
  //   to: "helpcenter",
  // },
];

class SchoolMenu extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      path: "",
      toLogin: false
    };

  }

  public componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
      return;
    }
  }

  public onLogout = (arg) => {
    this.setState({ toLogin: true });
  };

  public onMenuItemClick = (path) => {
    if (path === "helpcenter") {
      window.open("https://myperformancelearning.com/help", "_blank");
      return;
    }
    this.props.history.push(path);
  };

  public render(): ReactNode {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <Container>
        <Navbar logoutParent={this.onLogout} />
        <h1 className="menu-heading">
          Hey <span>{currentUser()}</span>
        </h1>
        <MenuGrid>
          {schoolItems.map((item, i) => (
            <Animated
              animationIn="fadeIn"
              animationOut="fadeOut"
              isVisible={true}
              animationInDuration={2000}
            >
              <MenuGridItem
                key={`school_menu_item_${i}`}
                highlightColor={item.color}
                backgroundImage={item.bg}
              >
                <div className="bg-holder" />

                <div className="menu-item-content">
                  <div>
                    <h2 className="menu-item-name">{item.title}</h2>
                    <p className="menu-item-description">{item.description}</p>
                  </div>
                  <button
                    onClick={this.onMenuItemClick.bind(this, item.to)}
                    className="menu-item-btn"
                  >
                    EXPLORE
                  </button>
                </div>
              </MenuGridItem>
            </Animated>
          ))}
        </MenuGrid>
      </Container>
    );
  }
}

export default withServices(SchoolMenu);



// WEBPACK FOOTER //
// ./src/pages/Schools/SchoolMenu.Component.tsx